export default "__VITE_ASSET__B2l3Q8N$__"